import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { formatTime } from '@doltech/utils/lib/date';
import * as React from 'react';
import Timer from 'react-compound-timer';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { TimeLimitSharedLayout } from './TimeLimitSharedLayout';

export const ListeningReviewTimeLimit = () => {
  const testSubmissionStore = useTestSubmissionStore();

  const { setRemainReviewTimeInSeconds, reviewTime, reviewedTime } = testSubmissionStore;
  const time = reviewTime - reviewedTime * 1000;

  if (!testSubmissionStore.isReviewing || !testSubmissionStore.isStartedDoingTest) return null;
  return (
    <TimeLimitSharedLayout
      uuid="1"
      onProgress={setRemainReviewTimeInSeconds}
      duration={time}
      onTimeUp={() => testSubmissionStore.openReviewTimeUpModal()}
      startImmediately
    >
      <Typography.Title style={{ color: colorsV2.gray100, margin: 0 }} variant="semi-bold/10">
        Review time
      </Typography.Title>
      <Timer
        key="2"
        initialTime={time}
        lastUnit="m"
        direction="backward"
        timeToUpdate={1000}
        startImmediately
      >
        <Typography.Text variant="medium/16" color="primary100">
          <Timer.Minutes formatValue={formatTime} />
          :
          <Timer.Seconds formatValue={formatTime} />
        </Typography.Text>
      </Timer>
    </TimeLimitSharedLayout>
  );
};
